"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[7233],{

/***/ 10698:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69541);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83913);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50556);
/* harmony import */ var analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66226);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91339);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1041);








var LogoLink = function(props) {
    var className = props.className, customLink = props.to, color = props.color;
    var subscription = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscription */ .m)().subscription;
    var defaultLink = (subscription === null || subscription === void 0 ? void 0 : subscription.hasNeverSubscribed) === false ? links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.subscription.main : cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.logoRedirectUrl) || links__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.home;
    var to = customLink === undefined ? defaultLink : customLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: className,
        to: to,
        color: color,
        onClick: function() {
            (0,analytics__WEBPACK_IMPORTED_MODULE_7__/* .track */ .j)("Scentbird logo click");
        }
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LogoLink);


/***/ }),

/***/ 25551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47361);
/* harmony import */ var compositions_LogoLink_LogoLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10698);
/* harmony import */ var compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25413);





var MinimalLayout = function(props) {
    var children = props.children, logoLink = props.logoLink, withoutHeader = props.withoutHeader, withFooter = props.withFooter;
    var isMobile = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex min-h-full flex-col",
        children: [
            !withoutHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: isMobile ? "pt-24 pb-8 text-center" : "pt-48 pb-16 text-center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_LogoLink_LogoLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    to: logoLink,
                    color: "black"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main",
                className: "flex-auto",
                children: children
            }),
            withFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MinimalLayout);


/***/ })

}]);